<template>
    <div class="md-form get-more-info-v3" :style="{ backgroundColor: bgColor }">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div
                v-if="title"
                class="mg-title"
                v-html="formatFontSize(title, '--mg-title-size')"
            ></div>
            <div class="form-container">
                <info-agent
                    v-if="!noAgent"
                    :agent="agent"
                    :licenseName="licenseName"
                    styleType="v2"
                />
                <info-form
                    :registerRole="registerRole"
                    :tag="tag"
                    :questionnaire="questionnaire"
                    :onSubmitOption="onSubmitOption"
                    :formList="formList"
                    messageOutside
                    showTitle
                    :lenderStyle="lenderStyle"
                    :defaultMsg="defaultMsg"
                    :submitText="submitOptionText"
                    :submitStyle="{
                        backgroundColor: submitBgColor,
                    }"
                    submitPos="right"
                    :registerLogin="registerLogin"
                    @done="handleShowToast"
                    disclaimerColor="#787878"
                    :disclaimerTeleportId="disclaimerWrapRef"
                />
                <form-toast
                    v-model:visible="formToastVisible"
                    v-bind="formToastOption"
                    @confirm="handleToastConfirm"
                />
            </div>
            <div class="disclaimer-form-v3" :ref="onRef"></div>
        </module-box>
    </div>
</template>

<script>
import util from '@/common/util';
import common from '../index';
import infoAgent from '../info-agent.vue';
import infoForm from '../info-form.vue';
import formToast from '@/components/form-toast';
import { normal } from '../../defaultSpacing';


export default {
    mixins: [common],
    data: function() {
        return {
            ...normal,
            disclaimerWrapRef: null
        };
    },
    components: {
        infoAgent,
        infoForm,
        formToast
    },
    methods: {
        onRef(e) {
            if (!util.isSSRServer) {
                this.disclaimerWrapRef = e;
            }
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-form.get-more-info-v3 {
    background-color: #ffffff;
    > div {
        &:not(.mg-container) {
            padding-left: 20px;
            padding-right: 20px;
        }
    }
    .form-container {
        position: relative;
        display: flex;
        padding-bottom: 20px;
        .info-agent {
            flex-shrink: 0;
            width: 166px;
            margin-right: 40px;
            .agent-image {
                width: 160px;
                height: 160px;
            }
            .agent-detail {
                text-align: left;
                margin-top: 20px;
                font-size: 14px;
                .name {
                    font-family: var(--font-bold);
                    line-height: 150%;
                }
                .position,
                .phone {
                    line-height: 150%;
                }
                .phone {
                    margin-top: 5px;
                    a {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .iconfont {
                        color: #8e98a3;
                        display: none;
                    }
                    span {
                        margin-left: 10px;
                        white-space: nowrap;
                    }
                }
                .position:not(.mobile) {
                    span {
                        display: block;
                    }
                }
                .position.mobile {
                    display: none;
                }
            }
        }
        .info-form {
            flex: 1;
            .input-content {
                display: flex;
                flex-wrap: wrap;
                margin-left: -40px;
            }
            .basic-info {
                width: 338px;
                min-width: 230px;
                max-width: 100%;
                flex: 1;
                display: flex;
                flex-wrap: wrap;
                align-self: flex-start;
                .input-box {
                    margin-left: 40px;
                    margin-bottom: 14px;
                    flex: 1;
                    min-width: 300px;
                    // display: flex;
                    // flex-direction: column;
                    .title {
                        font-size: 14px;
                        line-height: 21px;
                        color: var(--color-label);
                        font-family: var(--font-bold);
                        margin-bottom: 7px;
                        @include ellipsis();
                        span {
                            color: red;
                        }
                    }
                    &.meetTime {
                        .el-input {
                            width: 100%;
                        }
                    }
                }
                .input-box[class*='paragraphText'] {
                    width: 100%;
                    textarea {
                        width: 100%;
                        min-height: 143px;
                        border-radius: 3px;
                        padding: 12px;
                        font-size: 16px;
                        border: none;
                        box-shadow: none;
                        background-color: #f2f2f2;
                    }
                }
                input {
                    display: inline-block;
                    font-size: 14px;
                    color: #000000;
                    height: 40px;
                    background-color: #f2f2f2;
                    box-shadow: none;
                    border: none;
                    border-radius: 3px;
                    width: 100%;
                    padding-left: 12px;
                    padding-right: 12px;
                }
                .date-picker-input-wrapper input{
                    padding-left: 40px;
                }
            }
            .message {
                flex: 1;
                min-width: 230px;
                margin-left: 40px;
                display: flex;
                flex-direction: column;
                .title {
                    font-size: 14px;
                    line-height: 21px;
                    color: var(--color-label);
                    font-family: var(--font-bold);
                    margin-bottom: 7px;
                    @include ellipsis();
                    span {
                        color: red;
                    }
                }
                .input-container {
                    flex: 1;
                }
                textarea {
                    flex: 1;
                    width: 100%;
                    min-height: 143px;
                    border-radius: 3px;
                    padding: 12px;
                    font-size: 16px;
                    border: none;
                    box-shadow: none;
                    background-color: #f2f2f2;
                    height: 100%;
                }
            }
            .submit-box {
                margin-top: 20px;
                text-align: right;
            }
            .submit {
                display: inline-block;
                height: 40px;
                min-width: 120px;
                max-width: 100%;
                padding: 0 20px;
                border-radius: 2px;
                text-align: center;
                vertical-align: middle;
                font-size: 18px;
                font-family: var(--mg-button-font);
            }
        }
    }
    input[type='button'].toast-btn2 {
        font-family: var(--font-medium);
    }
    @include media-600 {
        > div {
            &:not(.mg-container) {
                padding-left: 15px;
                padding-right: 15px;
            }
        }
        .form-container {
            flex-direction: column;
            .info-agent {
                width: 100%;
                margin-right: 0;
                margin-bottom: 30px;
                .agent-detail {
                    text-align: left;
                    .phone a {
                        justify-content: flex-start;
                    }
                    .position:not(.mobile) {
                        display: none;
                    }
                    .position.mobile {
                        display: block;
                    }
                }
            }
            .info-form {
                width: 100%;
                .input-content {
                    margin-left: 0;
                }
                .basic-info {
                    width: 100%;
                    margin-left: 0;
                    .input-box {
                        flex: none;
                        width: 100%;
                        min-width: auto;
                        margin-left: 0;
                        margin-bottom: 9px;
                    }
                }
                .message {
                    width: 100%;
                    margin-left: 0;
                    display: block;
                }
            }
        }
    }
    .disclaimer-form-v3 {
        border-top: 1px solid #dcdcdc;
    }
}
</style>
